import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { ReferralHistory as UIReferralHistory } from "@jti/loyalty/components/ReferralHistory";

import type { referralHistoryInputs } from "./ReferralHistory.builder";

type ReferralHistoryBuilderProps = BuilderComponentProps<typeof referralHistoryInputs>;

export const ReferralHistory: FC<ReferralHistoryBuilderProps> = (props) => {
  return <UIReferralHistory {...props} isInEditor={isEditing()} />;
};
